import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KpiSidebarService } from './kpi-sidebar.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IKpiResponse } from '../interfaces/kpi/IKpiResponse';

@Injectable({
  providedIn: 'root',
})
export class RasterKpiService {
  private http: HttpClient = inject(HttpClient);
  private kpiSidebarService: KpiSidebarService = inject(KpiSidebarService);

  private API_URL = environment.services.urlEDI;

  constructor() {}

  loadRasterKPI(kpi_uuid: string): Observable<IKpiResponse> {
    return this.http.get<IKpiResponse>(`${this.API_URL}/kpi/${kpi_uuid}`);
  }
  loadRasterKPIsByProject(project_uuid: string): Observable<Array<{uuid : string , kpi_type : string, layer: string}>> {
    return this.http.get<Array<{uuid : string , kpi_type : string, layer : string}>>(`${this.API_URL}/kpi/project-kpi/${project_uuid}`);
  }
}
